import { useMemo } from "react";
import { AivArvActiveTab } from "../../../redux/types.ts";
import { ViewMode } from "../types.ts";

// TODO: AV-583
export const useSlidersByID = (
  viewMode: ViewMode,
  aivArvTab?: AivArvActiveTab,
) => useMemo(
  () =>
    ({ id }: { id: string }) => (
      <></>
    ),
  [aivArvTab, viewMode]
)
